<template>
  <w-settings-content-template>
    <div slot="content">
      <el-row class="title-bar" type="flex" justify="space-between">
        <div class="vertical-center-box">
          <div class="title-h3 mr-r15">로그 관리 설정</div>
        </div>
        <div class="vertical-center-box" align="right">
          <el-button class="mr-r4" type="primary" size="medium" :disabled="!checkDifferenceDataFlag" @click="onSaveButton">저장</el-button>
          <el-button size="medium" :disabled="!checkDifferenceDataFlag" @click="onCancelButton">취소</el-button>
        </div>
      </el-row>
      <hr class="mr-b20">
      <div class="list form-list">
        <el-form label-position="left" label-width="200px">
          <el-form-item label="로그 저장 위치">
            <el-input v-model="currentSettings.DIR"></el-input>
          </el-form-item>
          <el-form-item label="로그 저장 Level">
            <el-row type="flex" justify="space-between">
              <el-col :span="12" class="dot-title">
                로그 구분
              </el-col>
              <el-col :span="12" class="dot-title">
                저장 구분 형태
              </el-col>
            </el-row>
          </el-form-item>
          <el-form-item label="Level1">
            <el-row type="flex" justify="space-between">
              <el-col :span="12">
                <el-radio-group v-model="currentSettings.R1">
                  <el-radio-button v-for="type in logLevelTypeList" :key="`${type.basicinfoId}_${type.basicinfoSubid}`" :label="type.basicinfoSubid">
                    {{ type.basicinfoSubname }}
                  </el-radio-button>
                </el-radio-group>
              </el-col>
              <el-col :span="12">
                <el-radio-group v-model="currentSettings.T1">
                  <el-radio-button v-for="type in saveTypeList" :key="`${type.basicinfoId}_${type.basicinfoSubid}`" :label="type.basicinfoSubid">
                    {{ type.basicinfoSubname }}
                  </el-radio-button>
                </el-radio-group>
              </el-col>
            </el-row>
          </el-form-item>
          <el-form-item label="Level2">
            <el-row type="flex" justify="space-between">
              <el-col :span="12">
                <el-radio-group v-model="currentSettings.R2">
                  <el-radio-button v-for="type in logLevelTypeList" :key="`${type.basicinfoId}_${type.basicinfoSubid}`" :label="type.basicinfoSubid">
                    {{ type.basicinfoSubname }}
                  </el-radio-button>
                </el-radio-group>
              </el-col>
              <el-col :span="12">
                <el-radio-group v-model="currentSettings.T2">
                  <el-radio-button v-for="type in saveTypeList" :key="`${type.basicinfoId}_${type.basicinfoSubid}`" :label="type.basicinfoSubid">
                    {{ type.basicinfoSubname }}
                  </el-radio-button>
                </el-radio-group>
              </el-col>
            </el-row>
          </el-form-item>
          <el-form-item label="Level3">
            <el-row type="flex" justify="space-between">
              <el-col :span="12">
                <el-radio-group v-model="currentSettings.R3">
                  <el-radio-button v-for="type in logLevelTypeList" :key="`${type.basicinfoId}_${type.basicinfoSubid}`" :label="type.basicinfoSubid">
                    {{ type.basicinfoSubname }}
                  </el-radio-button>
                </el-radio-group>
              </el-col>
              <el-col :span="12">
                <el-radio-group v-model="currentSettings.T3">
                  <el-radio-button v-for="type in saveTypeList" :key="`${type.basicinfoId}_${type.basicinfoSubid}`" :label="type.basicinfoSubid">
                    {{ type.basicinfoSubname }}
                  </el-radio-button>
                </el-radio-group>
              </el-col>
            </el-row>
          </el-form-item>
          <el-form-item label="저장 시간 단위">
            <el-radio-group v-model="currentSettings.TT">
              <el-radio-button v-for="unit in saveDataUnitList" :key="`${unit.basicinfoId}_${unit.basicinfoSubid}`" :label="unit.basicinfoSubid">
                {{ unit.basicinfoSubname }}
              </el-radio-button>
            </el-radio-group>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </w-settings-content-template>
</template>

<script>
import findIndex from 'lodash/findIndex';
import isEqual from 'lodash/isEqual';
import cloneDeep from 'lodash/cloneDeep';
import forEach from 'lodash/forEach';
import isEmpty from 'lodash/isEmpty';
import sortBy from 'lodash/sortBy';

import WSettingsContentTemplate from '@/components/template/SettingsContentTemplate';
import msgUtils from '@/utils/message';
import LogManagementAPI from '@/api/settings/log/log-management-settings';

export default {
  name: 'WLogManagement',
  components: {
    WSettingsContentTemplate,
  },
  data() {
    return {
      currentSettings: {},
      currentSettingOrigins: {},
      logLevelTypeList: [],
      saveTypeList: [],
      saveDataUnitList: [],
      checkDifferenceDataFlag: false,
      basicinfoId: 'SLFR',
    };
  },
  mounted() {
    LogManagementAPI.getLogLevelTypeList().then((response) => {
      this.logLevelTypeList = sortBy(response.data.data, (item) => item.orderbyIndex);
    }).catch((e) => {
      this.$message(msgUtils.getResultMsgData(msgUtils.action.VIEW, '로그레벨 타입', false));
      throw new Error(e);
    });
    LogManagementAPI.getSaveTypeList().then((response) => {
      this.saveTypeList = sortBy(response.data.data, (item) => item.orderbyIndex);
    }).catch((e) => {
      this.$message(msgUtils.getResultMsgData(msgUtils.action.VIEW, '저장 구분 형태', false));
      throw new Error(e);
    });
    LogManagementAPI.getSaveDataUnitList().then((response) => {
      this.saveDataUnitList = sortBy(response.data.data, (item) => item.orderbyIndex);
    }).catch((e) => {
      this.$message(msgUtils.getResultMsgData(msgUtils.action.VIEW, '저장 시간 단위', false));
      throw new Error(e);
    });
    this.loadData();
  },
  watch: {
    currentSettings: {
      immediate: true,
      deep: true,
      handler() {
        this.changeDifferenceDataFlag();
      },
    },
  },
  methods: {
    /**
     * 현재 로그 관리 설정을 조회해온다.
     * @author Minyeong
     * @return {[type]} [description]
     */
    loadData() {
      LogManagementAPI.getCurrentLogSetting().then((response) => {
        if (response.data.success) {
          const currentSetting = response.data.data;
          this.currentSettings = {
            DIR: currentSetting[findIndex(currentSetting, (item) => item.basicinfoSubid === 'DIR')].basicinfoSubvalueString,
            R1: currentSetting[findIndex(currentSetting, (item) => item.basicinfoSubid === 'R1')].basicinfoSubvalueString,
            R2: currentSetting[findIndex(currentSetting, (item) => item.basicinfoSubid === 'R2')].basicinfoSubvalueString,
            R3: currentSetting[findIndex(currentSetting, (item) => item.basicinfoSubid === 'R3')].basicinfoSubvalueString,
            T1: currentSetting[findIndex(currentSetting, (item) => item.basicinfoSubid === 'T1')].basicinfoSubvalueString,
            T2: currentSetting[findIndex(currentSetting, (item) => item.basicinfoSubid === 'T2')].basicinfoSubvalueString,
            T3: currentSetting[findIndex(currentSetting, (item) => item.basicinfoSubid === 'T3')].basicinfoSubvalueString,
            TT: currentSetting[findIndex(currentSetting, (item) => item.basicinfoSubid === 'TT')].basicinfoSubvalueString,
          };
          this.currentSettingOrigins = cloneDeep(this.currentSettings);
        }
      }).catch((e) => {
        this.$message(msgUtils.getResultMsgData(msgUtils.action.VIEW, '로그 관리 설정', false));
        throw new Error(e);
      });
    },
    changeDifferenceDataFlag() {
      this.checkDifferenceDataFlag = !isEqual(this.currentSettings, this.currentSettingOrigins);
    },
    /**
     * 변경사항을 저장한다.
     * @author Minyeong
     * @return {[type]} [description]
     */
    onSaveButton() {
      if (isEmpty(this.currentSettings.DIR)) {
        this.$message(msgUtils.getCustomMsgData('로그 저장 위치를 입력해주세요.'));
        return;
      }
      const params = [];
      forEach(this.currentSettings, (value, key) => {
        const param = {
          basicinfoId: this.basicinfoId,
          basicinfoSubid: key,
          basicinfoSubvalueString: value,
        };
        params.push(param);
      });

      LogManagementAPI.updateCurrentLogSetting(params).then((response) => {
        if (response.data.success) {
          this.$message(msgUtils.getResultMsgData(msgUtils.action.SAVE, '변경사항', response.data.success));
          this.loadData();
        } else {
          this.$message(msgUtils.getResultMsgData(msgUtils.action.SAVE, '변경사항', response.data.success));
        }
      }).catch((e) => {
        this.$message(msgUtils.getResultMsgData(msgUtils.action.SAVE, '변경사항', false));
        throw new Error(e);
      });
    },
    onCancelButton() {
      this.currentSettings = cloneDeep(this.currentSettingOrigins);
    },
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/settings/log/log-management/index.vue